import { render, staticRenderFns } from "./recordlist.vue?vue&type=template&id=417a60ce&scoped=true"
import script from "./recordlist.vue?vue&type=script&lang=js"
export * from "./recordlist.vue?vue&type=script&lang=js"
import style0 from "./recordlist.vue?vue&type=style&index=0&id=417a60ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417a60ce",
  null
  
)

export default component.exports